import { NextPage } from 'next';

import { withSSRGuest } from '~/shared/utils/withSSRGuest';
import { SignIn } from '~/modules/auth/pages/SignIn';

export const getServerSideProps = withSSRGuest(async () => {
  return {
    props: {},
  };
});

const SignInPage: NextPage = () => {
  return <SignIn />;
};

export default SignInPage;
